export default __webpack_public_path__ + "static/media/2022_April_Papier.486069de.webp";